import { React } from '@1337lawyers/design';

export const PortalSplash = () => {
  return <React.Fragment>Please select an option on your left.</React.Fragment>;
};
